import { RegionsEnum } from 'src/generated/operations.ts';
import { targetUnits, targetUnitsAm } from 'src/modules/user-input/targetUnits.ts';

export const getTargetUnits = (
    region:RegionsEnum,
) => (region === RegionsEnum.Am ? targetUnitsAm : targetUnits);
